import EstadoCuenta from "../../components/EstadoCuenta";

const EstadoCuentaPage = () => <EstadoCuenta />;

export default EstadoCuentaPage;
